import React, { useMemo } from 'react';

import Viewer from '../../components/Viewer';

import { FSNModel, GoLiveFSNModel } from '../../types/common';

import { getViewerConfig } from '../../utils/viewerConfig';

import { useCommonStore } from '../../stores/commonStore';

import { Comment } from '../../icons';

interface ModelViewerProps {
    fsns: FSNModel[] | GoLiveFSNModel[] | null;
    showCommentButton?: boolean;
}

const ModelViewer = ({ fsns, showCommentButton = true }: ModelViewerProps) => {
    const activeProduct = useCommonStore((state) => state.activeFSN);

    const config = useMemo(() => {
        if (fsns?.length && activeProduct) {
            let selectedFSN = fsns.filter((p) => p.fsn === activeProduct)[0];

            if (!selectedFSN) return;

            return getViewerConfig(selectedFSN);
        }
    }, [activeProduct]);

    if (!config) return null;

    return (
        <>
            <div className="relative w-full h-full">
                {/* {showCommentButton ? (
                    <div className=" flex-row absolute right-3 bottom-8">
                        <button className=" block bg-fab-icon-bg p-3 mt-4 rounded-full">
                            <Comment />
                        </button>
                    </div>
                ) : null} */}

                <Viewer viewerConfig={config} />
            </div>
        </>
    );
};

export default React.memo(ModelViewer);
